import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import {
  Invoice,
  InvoicesByPhoneResponse,
} from '@core/interfaces/invoice.interface';
import { InvoicesService } from '@core/services/invoices/invoices.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-list-invoices',
  templateUrl: './list-invoices.component.html',
  styleUrls: ['./list-invoices.component.scss'],
})
export class ListInvoicesComponent implements OnInit {
  public searchPhone: string = '';
  public currentPhone: string = '';
  public listInvoices: Invoice[] = [];
  public totalItems: number = 0;

  displayedColumns: string[] = [
    'invoiceCode',
    'type',
    'clientName',
    'grandTotal',
    'createdAt',
    'action',
  ];

  dataSource = new MatTableDataSource<Invoice>([]);

  @ViewChild(MatPaginator) paginator: MatPaginator | undefined;

  constructor(public invoicesService: InvoicesService) {}

  ngOnInit(): void {}

  searchByPhone(): void {
    const phone = this.searchPhone.trim();
    if (!phone) return;

    this.currentPhone = phone;
    this.invoicesService.getInvoicesByPhone(phone).subscribe(
      (resp: InvoicesByPhoneResponse) => {
        if (resp.ok) {
          this.listInvoices = resp.invoices || [];
          this.totalItems = resp.total || 0;
          this.dataSource = new MatTableDataSource(this.listInvoices);
          if (this.paginator) {
            this.dataSource.paginator = this.paginator;
          }
        }
      },
      (err) => {
        console.error(err);
        this.listInvoices = [];
        this.totalItems = 0;
        this.dataSource = new MatTableDataSource<Invoice>([]);
      },
    );
  }

  downloadPdf(invoice: Invoice): void {
    const url = this.invoicesService.getInvoicePdfUrl(
      this.currentPhone,
      invoice.invoiceCode,
    );
    window.open(url, '_blank');
  }

  deleteInvoice(invoice: Invoice): void {
    Swal.fire({
      title: '¿Estás seguro?',
      text: `Se eliminará la factura ${invoice.invoiceCode}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#262D48',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.invoicesService
          .deleteInvoice(this.currentPhone, invoice.invoiceCode)
          .subscribe(
            () => {
              Swal.fire(
                'Eliminada',
                'La factura ha sido eliminada.',
                'success',
              );
              this.searchByPhone();
            },
            (err) => {
              console.error(err);
              Swal.fire('Error', 'No se pudo eliminar la factura.', 'error');
            },
          );
      }
    });
  }
}
